import { render, staticRenderFns } from "./OfferStatuses.vue?vue&type=template&id=2bbc0bba"
import script from "./OfferStatuses.vue?vue&type=script&lang=js"
export * from "./OfferStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports